define("calendar/routes/application", ["exports", "@ember/object/computed", "@ember/routing/route", "@ember/service", "@ember/utils", "@glimmer/tracking", "ember-concurrency", "later/utils/promise-hash"], function (_exports, _computed, _route, _service, _utils, _tracking, _emberConcurrency, _promiseHash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
  0; //eaimeta@70e063a35619d71f0,"@ember/object/computed",0,"@ember/routing/route",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/promise-hash"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let CalendarRoute = _exports.default = (_dec = (0, _computed.readOnly)('auth.currentAccount'), _dec2 = (0, _computed.readOnly)('auth.currentGroup'), _dec3 = (0, _computed.readOnly)('currentAccount.canCalendarNotes'), (_class = class CalendarRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "instagram", _descriptor4, this);
      _initializerDefineProperty(this, "progressBar", _descriptor5, this);
      _initializerDefineProperty(this, "segment", _descriptor6, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor7, this);
      _initializerDefineProperty(this, "store", _descriptor8, this);
      _initializerDefineProperty(this, "shouldShowTrialOptInModal", _descriptor9, this);
      _initializerDefineProperty(this, "currentAccount", _descriptor10, this);
      _initializerDefineProperty(this, "currentGroup", _descriptor11, this);
      _initializerDefineProperty(this, "canCalendarNotes", _descriptor12, this);
    }
    async activate() {
      this.send('setSideLibraryBehavior', 'calendar');
      if ((0, _utils.isEmpty)(this.currentGroup.socialProfiles)) {
        this.segment.track('viewed-open-calendar', {
          best_describes: this.currentAccount.bestDescribes,
          social_media_goal: this.currentAccount.socialMediaGoal,
          goal_with_later: this.currentAccount.goalWithLater
        });
      }
      this.progressBar.done('body');
    }
    async connectBusinessAccount(socialProfile) {
      await socialProfile.get('refreshAndReload').perform();
      await this.controller.connectBusinessAccount.perform(socialProfile);
    }
    async connectProfile(socialProfile) {
      if (socialProfile.hasProfessionalAccount && socialProfile.needsProfessionalTokenRefresh) {
        await this.connectBusinessAccount(socialProfile);
      } else {
        await this.connectPersonalAccount(socialProfile);
      }
    }
    async connectPersonalAccount(socialProfile) {
      try {
        await this.instagram.refreshInstagramToken(socialProfile);
      } catch (error) {
        this.errors.show(error);
      }
    }
    deactivate() {
      this.send('setSideLibraryBehavior', null);
      this.store.findAll('gram').then(grams => {
        grams.forEach(gram => {
          if (gram.id === null) {
            gram.unloadRecord();
          }
        });
      });
    }
    beforeModel() {
      this.progressBar.start('body');
    }
    async model() {
      const socialProfiles = this.selectedSocialProfiles.profiles;
      const posts = this.store.peekAll('gram');
      const notes = this.store.peekAll('calendar-note');
      let timeSlots;
      let calendarNotes;
      if (socialProfiles.get('length') === 1) {
        const socialProfile = socialProfiles.get('firstObject');
        try {
          await socialProfile.get('refreshAndReload').perform();
        } catch (error) {
          if (!(0, _emberConcurrency.didCancel)(error)) {
            this.errors.log(error);
          }
        }
        if ((0, _utils.isPresent)(socialProfile)) {
          timeSlots = socialProfile.get('timeSlots');
        }
      }
      if (this.canCalendarNotes) {
        calendarNotes = this.get('auth.currentGroup.calendarNotes');
      }
      return (0, _promiseHash.default)({
        timeSlots,
        calendarNotes,
        posts,
        notes,
        socialProfiles
      });
    }
    setupController(controller, model) {
      const instagramProfiles = model.socialProfiles.filter(profile => profile.isInstagram);
      controller.setProperties({
        instagramProfiles,
        posts: model.posts,
        notes: model.notes,
        showCalendarNotes: this.cache.retrieve('showCalendarNotes') || true,
        displayAdvanced: true
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "instagram", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "progressBar", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "shouldShowTrialOptInModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "currentAccount", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "currentGroup", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "canCalendarNotes", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
});